import * as Sentry from '@sentry/sveltekit';
import { handleErrorWithSentry } from '@sentry/sveltekit';
import { configureApi } from '@voicedojo/api';
import { API_ORIGIN, ApiError } from '$lib/api/client';
import { toastUnhandledRejection } from '$lib/api/rejectionToast';
import { toastWhileLiveUpdatesPaused } from '$lib/api/hubConnection';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN ?? '';
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    release: import.meta.env.VITE_APP_VERSION ?? '0.0.0-dev',
    environment: import.meta.env.VITE_BUILD_CHANNEL ?? 'dev',
    tracesSampleRate: 0,
    integrations: [],
  });
}

export const handleError = handleErrorWithSentry();

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    toastUnhandledRejection(reason);
    if (reason instanceof ApiError) {
      event.preventDefault();
      if (sentryDsn && (reason.status >= 500 || reason.status === 0)) Sentry.captureException(reason);
    }
  });
}

configureApi({ baseUrl: API_ORIGIN });

toastWhileLiveUpdatesPaused();

// Memoized with the root layout's call: one whoami.
void import('$lib/stores/auth').then(({ bootstrapAuth }) => bootstrapAuth());
